import axios from 'axios'
import { createApp } from 'vue'
import { Customer } from '~/js/models/customer'
import {
  ERROR_MESSAGE_EMAIL_FORMAT,
  ERROR_MESSAGE_EMAIL_ALREADY_REGISTERED,
  ERROR_MESSAGE_UNEXPECTED,
} from '~/js/constants/errorMessages'
import { isApp } from '~/js/helpers/user-agent-helper'

const ID_CUSTOMERS_REGISTER = 'js-customers-register'

document.addEventListener('DOMContentLoaded', () => {
  const elementCustomersRegister = document.getElementById(
    ID_CUSTOMERS_REGISTER
  )
  if (!elementCustomersRegister) return

  const { baseUrl, returnTo } = elementCustomersRegister.dataset
  createApp({
    name: 'TemplatesCustomersRegister',
    data() {
      return {
        email: '',
        errorMessage: '',
        isAgreed: false,
        isProcessing: false,
      }
    },
    computed: {
      isSubmitValid() {
        return this.isAgreed && !!this.email && !this.isProcessing
      },
    },
    methods: {
      async onSubmit() {
        this.errorMessage = Customer.getEmailError(this.email)
        if (this.errorMessage) return

        this.isProcessing = true
        try {
          await axios.post(`${baseUrl}/customers/create_customer`, {
            emailAddress: this.email,
            isYappli: isApp(),
          })
          window.location = returnTo
        } catch (error) {
          this.isProcessing = false
          const message = error.response && error.response.data.result
          switch (message) {
            case 'Invalid email address format':
              this.errorMessage = ERROR_MESSAGE_EMAIL_FORMAT
              break
            case 'Email address is already registered':
              this.errorMessage = ERROR_MESSAGE_EMAIL_ALREADY_REGISTERED
              break
            default:
              this.errorMessage = ERROR_MESSAGE_UNEXPECTED
          }
          console.error(error)
        }
      },
    },
  }).mount(elementCustomersRegister)
})
